<template>
  <div class="componentSty">
    <m-title :titlelist="listitem"></m-title>
    <div class="componentSty_content">
      <div class="componentSty_content_title">
        <span class="fonints">公告列表</span>
        <div style="float:right;padding:0 10px;">
          <button
           class="buttons"
            style="background: #17B6A1; color: #fff"
            @click="addnoticelist(false)"
          >
            添加公告
          </button>
          <span class="fonints">选择分类:</span>
          <div class="select_box">
            <m-select
              :list="dropdownitemlist3"
              v-model="selectitem3"
            ></m-select>
          </div>
        </div>
      </div>
      <div class="componentSty_content_table">
        <el-table :data="arrlist.list" style="width: 100%; height: 80%"  height="80%">
           <el-table-column
            label="序号"
            type="index"
            width="50px"
          ></el-table-column>
          <el-table-column prop="noticeType" label="分类"> </el-table-column>
          <el-table-column prop="noticeTitle" label="标题"> </el-table-column>
          <el-table-column  label="发布时间">
            <template v-slot="res">
                {{mydateFormat(res.row.gmtCreate,'时分秒')}}
            </template>
             </el-table-column>
          <el-table-column label="状态">
            <template v-slot="res">
              <span
                v-if="res.row.state === 1"
                class="el_spanfontstyle"
                style="color: #ff5926"
                >已禁用</span
              >
              <span
                v-if="res.row.state === 0"
                class="el_spanfontstyle"
                style="color: #13d168"
                >已启用</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template v-slot="res">
              <span
                v-if="res.row.state === 1"
                class="iconfont icon-jinyong"
                @click="editstate(res.row)"
              ></span>
              <span
                v-if="res.row.state === 0"
                class="iconfont icon-qiyong"
                @click="editstate(res.row)"
              ></span>
              <span
                v-if="res.row.id"
                class="iconfont icon-xiugai"
                @click="addnoticelist(res.row)"
              ></span>
              <span
                v-if="res.row.id"
                class="iconfont icon-shanchu"
                @click="deleitem(res.row.id)"
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginations" v-show="arrlist.list&&arrlist.list.length">
          <el-pagination
            :page-size="selectitem.limit"
             layout="total,prev, pager,next, jumper"
            :total="arrlist.totalCount"
            :current-page="selectitem.page"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mTitle from "@/components/mTitle.vue";
import mSelect from "@/components/mSelect";
import { mapGetters,mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      listitem: [{name:"公告管理"}, {name:"公告列表"}],
      dropdownitemlist: [],
      selectitem: {
        page: 1,
        limit: 20,
        noticeType: "",
      },
      selectitem3: "全部",
      dropdownitemlist3: [],
      arrlist: [],
    };
  },
  computed: {
    ...mapState(["conditionsList"]),
    ...mapGetters(["usergt"]),
  },
  watch: {
    selectitem3(nval) {
      this.selectitem.noticeType = nval;
      if (nval == "全部") this.selectitem.noticeType = "";
      this.getnoticelist();
    },
  },
  created() {
     this.conditionsList[this.$route.path] ||
      this.createConditions({ key: this.$route.path });
    this.selectitem = this.conditionsList[this.$route.path] || {
      page: 1,
      limit: 20,
    };
    this.selectitem.noticeType&&(this.selectitem3=this.selectitem.noticeType||"全部")
    this.getnoticelist();
    this.gnoticeinfo();
  },
  components: {
    mTitle,
    mSelect,
  },
  methods: {
    ...mapMutations(["addnavigationMsg","createConditions"]),
    async getnoticelist() {
      const { data } = await this.$http(
        "api1",
        "/notice/message/list",
        "get",
        this.selectitem
      );
      if (!data || data.msg != "success")
        return this.$message.error("获取数据失败");
      this.arrlist = data.page;
    },
    async editstate(res) {
      let state = res.state === 0 ? 1 : 0;
      res.state = state;
      this.$http("api1", "/notice/message/update", "post", {
        state: state,
        peopleModified: this.usergt.username,
        id: res.id,
      });
    },
    async gnoticeinfo() {
      const { data: data2 } = await this.$http(
        "api1",
        "/sys/dic/list?dictionaryType=" + "公告类型",
        "get"
      );
      this.dropdownitemlist3 = data2.data.reduce(
        (result, item) => {
          result.push(item.val);
          return result;
        },
        ["全部"]
      );
    },
    handleCurrentChange(index) {
      if (this.arrlist.totalCount < this.selectitem.limit) return;
      this.selectitem.page = index;
      this.getnoticelist();
    },
    addnoticelist(obj) {
      if (!obj) {
        this.addnavigationMsg([{name:"公告管理"},{name:"公告列表",path:"/notice/noticelist"},{name:"添加公告"}]);
        return this.$router.replace("/notice/addnoticelist/add");
      }
      else{
        window.sessionStorage.setItem("noticeeditinfo",JSON.stringify(obj));
        this.addnavigationMsg([{name:"公告管理"},{name:"公告列表",path:"/notice/noticelist"},{name:"修改公告"}]);
        return this.$router.replace("/notice/addnoticelist/edit");
      } 
    },
    deleitem(id) {
      this.$messageBox
        .confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          const { data } = await this.$http(
            "api1",
            "/notice/message/delete",
            "post",
            { ids: [id] }
          );
          if (!data || data.msg != "success")
            return this.$message.error("获取数据失败");
          this.$message.success("删除成功");
          this.getnoticelist();
        })
        .catch(err=>err);
    },
  },
};
</script>
<style lang="scss" src="@/assets/components.scss" scoped></style>
